import React from 'react';
import { Tooltip } from '@mui/material';
import * as Styles from './ProductCard.styles';
import { ProductCardActionType } from './ProductCard.types';

type AdvancedInfoProps = {
  entityId?: string | number;
  actionType: ProductCardActionType;
  productUrl?: string;
  isHover: boolean;
  isAddToCartLoading: boolean;
  isAddedToCart: boolean;
  disabled: boolean;
  hideActionButton: boolean;
  showSelect: boolean;
  actionButtonLabel?: string;
  addToCartHoverLabel?: string;
  addToCartTooltipLabel?: string;
  isCustomAction: boolean;
  onActionButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export function AdvancedInfo({
  entityId,
  actionType,
  productUrl,
  isHover,
  isAddToCartLoading,
  isAddedToCart,
  disabled,
  hideActionButton,
  showSelect,
  actionButtonLabel,
  addToCartHoverLabel,
  addToCartTooltipLabel,
  isCustomAction,
  onActionButtonClick,
}: AdvancedInfoProps) {
  return (
    <Tooltip title={addToCartTooltipLabel} placement="top" arrow>
      <Styles.ActionButtonContainer>
        <Styles.ActionButton
          id={
            entityId != null
              ? `search_item_${entityId}_action_button`
              : undefined
          }
          data-testid="add-to-cart"
          href={actionType === 'link' ? productUrl : undefined}
          variant="contained"
          color={
            isHover || isAddToCartLoading || isAddedToCart
              ? 'primary'
              : 'secondary'
          }
          startIcon={
            actionType === 'addToCart' && isAddedToCart ? 'check' : undefined
          }
          isStartIconCircularProgress={isAddToCartLoading}
          fullWidth
          disabled={disabled}
          hidden={hideActionButton || showSelect}
          onClick={onActionButtonClick}
        >
          <span className="buttonLabel">
            {isHover && addToCartHoverLabel && !isCustomAction
              ? addToCartHoverLabel
              : actionButtonLabel}
          </span>
        </Styles.ActionButton>
      </Styles.ActionButtonContainer>
    </Tooltip>
  );
}
